export enum ColorsRasterEnum {
    raster1 = "#1A237E",
    raster2 = "#00a800",
    raster3 = "#B71C1C",
    raster4 = "#D35400",
    raster5 = "#6C3483"
}